<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="pumpsHeadings" :data="pumps" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onPumpActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddPumpClick">Add Pump</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'pumpsFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="pumpMarkAsActiveInactiveModal.heading"
                :modalId="pumpMarkAsActiveInactiveModal.modalId"
                :isSaving="pumpMarkAsActiveInactiveModal.isSaving"
                :showModal="pumpMarkAsActiveInactiveModal.showModal"
                :isActive="pumpMarkAsActiveInactiveModal.isActive"
                @closeClicked="pumpMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="pumpAddEditFormModal.heading"
            :modalId="pumpAddEditFormModal.modalId"
            :isSaving="pumpAddEditFormModal.isSaving"
            :showModal="pumpAddEditFormModal.showModal"
            @closeClicked="onAddOrEditPumpModalCloseClick"
            @saveButtonClicked="onAddOrEditPumpSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="pumpNumberTankRegistrationInput">
                        Pump Number/Tank Registration
                    </label>
                    <div class="text-danger" v-if="pumpAddEditFormModal.pump.pumpNumberTankRegistration.hasError">
                        {{pumpAddEditFormModal.pump.pumpNumberTankRegistration.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="pumpNumberTankRegistrationInput" v-model="pumpAddEditFormModal.pump.pumpNumberTankRegistration.value"/>
                </div>
                <div class="form-group">
                    <label for="bauzerInput">
                        Bauzer
                    </label>
                    <div class="text-danger" v-if="pumpAddEditFormModal.pump.bauzer.hasError">
                        {{pumpAddEditFormModal.pump.bauzer.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="bauzerInput" v-model="pumpAddEditFormModal.pump.bauzer.value"/>
                </div>
            </form>
        </template>
    </modal-form>
</div>
